<template>
  <ModulesPartnerPlaylist>
    <slot />
  </ModulesPartnerPlaylist>
</template>
